import { devLog, devWarn, devError } from '../utils/devLogger';

// 구글 로그인 SDK 초기화 및 유틸리티 함수
declare global {
  interface Window {
    google: any;
    gapi: any;
  }
}

// 구글 SDK 초기화
export const initGoogleSDK = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    
    if (!clientId || clientId === 'your-google-client-id.apps.googleusercontent.com') {
      devError('구글 클라이언트 ID가 설정되지 않았습니다. 환경변수를 확인해주세요.');
      return false;
    }

    // 구글 SDK가 로드되었는지 확인
    if (!window.google || !window.google.accounts) {
      devWarn('구글 SDK가 아직 로드되지 않았습니다.');
      return false;
    }

    devLog('구글 SDK 초기화 완료', { clientId });
    return true;
    
  } catch (error) {
    devError('구글 SDK 초기화 실패:', error);
    return false;
  }
};

// 구글 로그인
export const googleLogin = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
      
      if (!clientId || clientId === 'your-google-client-id.apps.googleusercontent.com') {
        reject(new Error('구글 클라이언트 ID가 설정되지 않았습니다. 환경변수를 확인해주세요.'));
        return;
      }

      if (!window.google || !window.google.accounts) {
        reject(new Error('구글 SDK가 로드되지 않았습니다.'));
        return;
      }

      devLog('구글 OAuth2 팝업 로그인 시작...');

      // OAuth2 팝업 방식으로 직접 로그인 (FedCM 경고 방지)
      const tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: 'email profile openid',
        callback: (response: any) => {
          devLog('구글 OAuth2 응답:', response);
          
          if (response.access_token) {
            // 사용자 정보 가져오기
            fetch(`https://www.googleapis.com/oauth2/v2/userinfo?access_token=${response.access_token}`)
              .then(res => {
                if (!res.ok) {
                  throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
              })
              .then(userInfo => {
                devLog('구글 사용자 정보:', userInfo);
                
                const googleData = {
                  accessToken: response.access_token,
                  userInfo: userInfo,
                  providerId: userInfo.id
                };
                
                devLog('구글 로그인 성공:', googleData);
                resolve(googleData);
              })
              .catch(error => {
                devError('구글 사용자 정보 조회 실패:', error);
                reject(new Error('구글 사용자 정보 조회에 실패했습니다.'));
              });
          } else if (response.error) {
            devError('구글 OAuth2 오류:', response.error);
            if (response.error === 'popup_closed_by_user') {
              reject(new Error('사용자가 로그인을 취소했습니다.'));
            } else {
              reject(new Error(`구글 로그인 오류: ${response.error}`));
            }
          } else {
            reject(new Error('구글 액세스 토큰을 받지 못했습니다.'));
          }
        },
        error_callback: (error: any) => {
          devError('구글 OAuth2 에러:', error);
          reject(new Error('구글 로그인 중 오류가 발생했습니다.'));
        }
      });

      // 팝업 방식으로 로그인 요청
      tokenClient.requestAccessToken();

    } catch (error) {
      devError('구글 로그인 실행 중 오류:', error);
      reject(error);
    }
  });
};

// 구글 로그아웃
export const googleLogout = (): Promise<void> => {
  return new Promise((resolve) => {
    try {
      if (window.google && window.google.accounts) {
        // OAuth2 토큰 해제
        window.google.accounts.oauth2.revoke && window.google.accounts.oauth2.revoke();
        devLog('구글 로그아웃 완료');
      }
    } catch (error) {
      devLog('구글 로그아웃 처리 중 오류:', error);
    }
    resolve();
  });
};
